<div #modalBackground class="modal" *ngIf="show" [hidden]="!show"
     (click)="(closable && $event.srcElement == modalBackground) ? close($event, modalBackground) : return;">
  <mat-card class="fsmodal-box limit-preview">
    <mat-card-content class="modal-content">
      <ng-content select=".modal-body-content">
      </ng-content>
    </mat-card-content>
  </mat-card>
</div>

